import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Aktie } from '../entities/boerse/aktie.entity';
import { AktienTrends } from '../entities/boerse/aktientrends.entity';
import { Tageslinie } from '../entities/boerse/tageslinie.entity';
//#endregion

@Injectable()
export class AktienTrendsService extends ODataEntityService<AktienTrends> {
  constructor(protected client: ODataClient) {
    super(client, 'AktienTrends', 'entities.boerse.AktienTrends');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public aktie(entity: EntityKey<AktienTrends>): ODataNavigationPropertyResource<Aktie> {
    return this.entity(entity).navigationProperty<Aktie>('aktie');
  }
  public tageslinie(entity: EntityKey<AktienTrends>): ODataNavigationPropertyResource<Tageslinie> {
    return this.entity(entity).navigationProperty<Tageslinie>('tageslinie');
  }
  //#endregion
}
